import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 9H5.414l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L5.414 11H17a1 1 0 1 0 0-2",
  fillRule: "evenodd"
});

var SvgArrowLeftMinor = function SvgArrowLeftMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgArrowLeftMinor as S };
